<script setup lang="ts">
withDefaults(
  defineProps<{
    dark?: boolean
  }>(),
  { dark: false },
)
</script>

<template>
  <a href="/" class="cc3-auth-logo">
    <svg
      width="140"
      height="30"
      viewBox="0 0 168 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :class="{ dark }"
    >
      <path
        d="M157.723 7.86866C154.584 7.86866 152.189 9.04672 150.497 11.4028V0H146.04V29.4516H150.497V26.4227C152.189 28.8302 154.577 30 157.723 30C160.57 30 162.964 28.9479 164.987 26.8022C167.009 24.6565 168.001 22.0054 168.001 18.9335C168.001 15.8202 167.011 13.2122 164.987 11.0665C162.963 8.9208 160.57 7.86866 157.723 7.86866V7.86866ZM152.356 23.775C151.117 22.471 150.504 20.8721 150.504 18.9368C150.504 17.0015 151.124 15.4026 152.356 14.1401C153.594 12.8361 155.161 12.2048 157.02 12.2048C158.879 12.2048 160.447 12.8361 161.685 14.1401C162.919 15.4026 163.537 17.0043 163.537 18.9451C163.537 20.8804 162.919 22.4793 161.685 23.7833C160.447 25.0458 158.878 25.6771 157.02 25.6771C155.163 25.6771 153.594 25.0458 152.356 23.7833"
        fill="white"
      />
      <path d="M119.496 0H115.037V29.4516H119.496V0Z" fill="white" />
      <path
        d="M142.16 29.4516V8.40881H137.701V20.5672C137.701 23.4917 135.657 25.6589 132.767 25.6589C129.649 25.6589 127.835 23.7717 127.835 20.6318V8.41544H123.377V21.4255C123.377 26.7823 126.468 30 131.796 30C134.242 30 136.26 29.1251 137.708 27.0722V29.4516H142.16Z"
        fill="white"
      />
      <path
        d="M102.963 7.86865C99.949 7.86865 97.3492 8.92079 95.2444 11.0665C93.1396 13.2122 92.0653 15.8202 92.0653 18.9335C92.0653 22.0468 93.1379 24.6565 95.2444 26.8022C97.3509 28.9479 99.949 30 102.963 30C105.93 30 108.415 28.9479 110.46 26.8022C111.155 26.0777 111.751 25.266 112.231 24.388L108.607 22.2523C108.316 22.7865 107.954 23.2802 107.53 23.7203C106.956 24.3471 106.251 24.8453 105.465 25.1809C104.678 25.5165 103.827 25.6818 102.97 25.6655C99.2503 25.6655 96.5309 22.7328 96.5309 18.9335C96.5309 15.1342 99.2503 12.2015 102.97 12.2015C103.827 12.1855 104.678 12.3511 105.465 12.687C106.252 13.0229 106.956 13.5213 107.53 14.1483C107.954 14.5883 108.316 15.082 108.607 15.6164L112.238 13.4806C111.757 12.6018 111.159 11.7899 110.46 11.0665C108.415 8.91251 105.93 7.86865 102.963 7.86865"
        fill="white"
      />
      <path d="M89.0121 0H84.5533V29.4516H89.0121V0Z" fill="white" />
      <path
        d="M68.9915 7.86865C72.1285 7.86865 74.5229 9.04671 76.2152 11.4028V8.4204H80.674V29.4632H76.2152V26.4227C74.5229 28.8219 72.1285 30 68.9915 30C66.1425 30 63.7497 28.9479 61.7274 26.8022C59.7052 24.6565 58.7134 22.0054 58.7134 18.9335C58.7134 15.8202 59.7035 13.2122 61.7274 11.0665C63.7514 8.92079 66.1425 7.86865 68.9915 7.86865V7.86865ZM74.3579 23.775C75.5972 22.471 76.2102 20.8721 76.2102 18.9368C76.2102 17.0015 75.5905 15.4026 74.3579 14.1401C73.1203 12.8361 71.551 12.2048 69.6937 12.2048C67.8364 12.2048 66.2671 12.8361 65.0295 14.1401C63.7946 15.4026 63.1772 17.0043 63.1772 18.9451C63.1772 20.8804 63.7952 22.4793 65.0295 23.7833C66.2671 25.0458 67.8364 25.6771 69.6937 25.6771C71.551 25.6771 73.1203 25.0458 74.3579 23.7833"
        fill="white"
      />
      <path
        d="M33.0046 7.86865C29.9922 7.86865 27.3924 8.92079 25.2859 11.0665C23.1794 13.2122 22.1068 15.8202 22.1068 18.9335C22.1068 22.0468 23.1811 24.6565 25.2859 26.8022C27.3907 28.9479 30.0007 30 33.0046 30C36.0086 30 38.6185 28.9479 40.7233 26.8022C42.8281 24.6565 43.9024 22.0468 43.9024 18.9335C43.9024 15.8202 42.8298 13.2122 40.7233 11.0665C38.6169 8.92079 36.0187 7.86865 33.0046 7.86865ZM33.0046 25.6655C29.2867 25.6655 26.5656 22.7328 26.5656 18.9335C26.5656 15.1342 29.2867 12.2031 33.0046 12.2031C36.7225 12.2031 39.4453 15.1359 39.4453 18.9335C39.4453 22.7311 36.7242 25.6655 33.0046 25.6655Z"
        fill="white"
      />
      <path
        d="M51.412 29.4532V18.6701C51.412 15.0564 53.037 12.4235 57.5412 12.4633V7.9184C54.9346 8.16693 52.9022 9.32843 51.412 11.3979V8.41547H46.9532V29.4582L51.412 29.4532Z"
        fill="white"
      />
      <path
        d="M10.8978 7.86865C7.88542 7.86865 5.28389 8.92079 3.17909 11.0665C1.07429 13.2122 0 15.8202 0 18.9335C0 22.0468 1.07429 24.6565 3.17909 26.8022C5.28389 28.9479 7.89384 30 10.8978 30C13.8647 30 16.3501 28.9479 18.3959 26.8022C19.0913 26.0776 19.6864 25.2659 20.1657 24.388L16.537 22.2523C16.2448 22.7861 15.8825 23.2796 15.4593 23.7203C14.8849 24.347 14.1803 24.845 13.3934 25.1806C12.6064 25.5162 11.7553 25.6816 10.8978 25.6655C7.17821 25.6655 4.45881 22.7328 4.45881 18.9335C4.45881 15.1342 7.17989 12.2031 10.8978 12.2031C11.7553 12.1871 12.6064 12.3524 13.3934 12.688C14.1803 13.0236 14.8849 13.5216 15.4593 14.1483C15.8829 14.5883 16.2448 15.082 16.5353 15.6164L20.1657 13.4806C19.6872 12.6022 19.0921 11.7904 18.3959 11.0665C16.3501 8.91251 13.8647 7.86865 10.8978 7.86865"
        fill="white"
      />
    </svg>
  </a>
</template>

<style lang="scss" scoped>
.cc3-auth-logo {
  display: inline-block;
  line-height: 0;
}

svg {
  path {
    fill: #fff;
    transition: all 0.4s ease-in-out;
  }
  &.dark path {
    fill: #333f48;
  }
}
</style>
